import SimpleHeader from '../../components/layout/SimpleHeader';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectCampus from '../../components/SelectCampus';
import Button from '../../components/Button';
import { Select, Table, TableColumnsType } from 'antd';
import Pagination from '../../components/Pagination';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import ErrorResponse from '../../components/ErrorResponse';
import { getCommonCodeLabel } from '../../lib/store';
import {
  useGetCheckedOutBooksQuery,
  useLazyGetCheckedOutBooksQuery,
  useSaveOverdueSMSMutation,
} from '../../api/books/bookManagement.api';
import moment from 'moment/moment';
import { useSnackbar } from 'notistack';
import { infoVariant, successVariant } from '../../lib/barVariant';
import useAxios from '../../hooks/useAxios';
import { IClassList, IGetClasses } from '../../models/campusClasses.model';
import { ICurrentSemester, IGetCurrentSemester } from '../../models/semesters.model';
import { getClasses } from '../../api/campusClasses.api';
import { getCurrentSemester, getCurrentSemesterByType } from '../../api/semesters.api';
import { getEmployees } from '../../api/employees.api';
import DownloadButton from '../../components/DownloadButton';
import _ from 'lodash';
import exportTable from '../../lib/exportTable';
import { addHyphen } from '../../lib/util';
import useBarcodeScanner from '../../hooks/useBarcodeScanner';

const CheckedOutBooks = () => {
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { currentCampus: campusCode } = useSelector(
    (state: RootState) => state.auth,
  );
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find((item) => item.commonCode === 'PR0002')?.detailCode;
  const [classCode, setClassCode] = useState<string | undefined>(undefined);
  const [teacherMemberCode, setTeacherMemberCode] = useState<
    string | undefined
  >(undefined);
  const [page, setPage] = useState(1);
  const barcode = useBarcodeScanner();
  const keywordRef = useRef<any>();
  const studentKeywordRef = useRef<any>();
  const [searchData, setSearchData] = useState<any>({
    classCode: undefined,
    teacherMemberCode: undefined,
    campusCode,
    studentKeyword: '',
    bookKeyword: '',
    pageSize: 10,
    page: 1,
    semesterType: undefined,
  });

  const [selectedBooks, setSelectedBooks] = useState<any>([]);
  const [selectedBooksKeys, setSelectedBooksKeys] = useState<React.Key[]>([]);

  const {
    data: checkedOutResponse,
    isFetching,
    error,
  } = useGetCheckedOutBooksQuery(searchData, { skip: !searchData?.campusCode });
  const [checkoutBooksTrigger] = useLazyGetCheckedOutBooksQuery();
  const [
    overdueSMSSendTrigger,
    { isSuccess: isOverdueSMSSuccess, isLoading: isOverdueSMSLoading },
  ] = useSaveOverdueSMSMutation();
  const { data: scClassList, execute: scClassExecute } = useAxios<IGetClasses>();
  const { data: rgClassList, execute: rgClassExecute } = useAxios<IGetClasses>();
  const { data: scSemesterData, execute: scSemesterExecute } =
    useAxios<IGetCurrentSemester>();
  const { data: rgSemesterData, execute: rgSemesterExecute } =
    useAxios<IGetCurrentSemester>();
  const { data: res, error: teachersError, execute } = useAxios<any>();

  const checkedOutBooks = checkedOutResponse?.data;
  //const currentSemester = semesterData?.data;
  const [scCurrentSemester, setScCurrentSemester] = useState<ICurrentSemester>();
  const [rgCurrentSemester, setRgCurrentSemester] = useState<ICurrentSemester>();
  const [semesterType, setSemesterType] = useState('');
  const [classList, setClassList] = useState<IClassList[]>([]);

  const returnBooksColumns: TableColumnsType<any> = [
    {
      title: 'No',
      dataIndex: 'id',
      align: 'center',
      width: 50,
      ellipsis: true,
      render: (item, record, index) => (
        <>{(page - 1) * searchData.pageSize + index + 1}</>
      ),
    },
    {
      title: t('booksManagement.books.column14'),
      dataIndex: 'memberName',
      align: 'center',
      ellipsis: true,
      render: (value, record: any) => `${value}(${record!.webId})`,
      sorter: (a, b) => a.memberName.localeCompare(b.memberName),
    },
    {
      title: t('booksManagement.books.column15'),
      dataIndex: 'memberCode',
      align: 'center',
      sorter: (a, b) => a.memberCode.localeCompare(b.memberCode),
    },
    {
      title: t('booksManagement.books.column16'),
      dataIndex: 'classStudentStatusCode',
      align: 'center',
      ellipsis: true,
      render: (value) =>
        getCommonCodeLabel('CL0003', value?.trim() || '', i18n.language),
      sorter: (a, b) =>
        getCommonCodeLabel(
          'CL0003',
          a.classStudentStatusCode?.trim() || '',
          i18n.language,
        ).localeCompare(
          getCommonCodeLabel(
            'CL0003',
            b.classStudentStatusCode?.trim() || '',
            i18n.language,
          ),
        ),
    },
    {
      title: t('booksManagement.books.column17'),
      dataIndex: 'className',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.className.localeCompare(b.className),
    },
    {
      title: t('booksManagement.books.column18'),
      dataIndex: 'teacherName',
      align: 'center',
      ellipsis: true,
      render: (value: string) =>
        value ? getCommonCodeLabel('BK0002', value, i18n.language) : '-',
      sorter: (a, b) => a.teacherName.localeCompare(b.teacherName),
    },
    {
      title: t('booksManagement.books.column2'),
      dataIndex: 'bookName',
      align: 'center',
      width: '25%',
      ellipsis: true,
      sorter: (a, b) => a.bookName.localeCompare(b.bookName),
      render: value => {
        return (<div className='text-left ant-table-cell-ellipsis'>{value}</div>);
      }
    },
    {
      title: t('booksManagement.books.column4'),
      dataIndex: 'isbn',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.isbn.localeCompare(b.isbn),
    },
    {
      title: t('booksManagement.books.column19'),
      dataIndex: 'bookSeq',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.bookSeq - b.bookSeq,
    },
    {
      title: t('booksManagement.books.column20'),
      dataIndex: 'lendingDate',
      align: 'center',
      ellipsis: true,
      render: (value) => moment(value).format('YYYY-MM-DD'),
      sorter: (a, b) => a.lendingDate.localeCompare(b.lendingDate),
    },
    {
      title: t('booksManagement.books.column21'),
      dataIndex: 'returnPlanDate',
      align: 'center',
      ellipsis: true,
      render: (value, record: any) => {
        return record?.overdueDay ? (
          <>
            {moment(record?.returnPlanDate).format('YYYY-MM-DD')}
            <span style={{ color: 'red' }}>
              ({record?.overdueDay}
              {t('booksManagement.books.column22')})
            </span>
          </>
        ) : value ? (
          moment(value).format('YYYY-MM-DD')
        ) : (
          '-'
        );
      },
      sorter: (a, b) => a.returnPlanDate.localeCompare(b.returnPlanDate),
    },
    {
      title: t('booksManagement.books.column23'),
      dataIndex: 'smsSender',
      align: 'center',
      render: (value) => (value ? 'Y' : '-'),
      sorter: (a, b) => a.smsSender.localeCompare(b.smsSender),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedBooksKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectedBooks(selectedRows);
      setSelectedBooksKeys(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      disabled: !record?.overdueDay,
    }),
  };
  const handleSelectedReset = () => {
    setSelectedBooksKeys([]);
    setSelectedBooks([]);
  };

  const handleExcelTable = async () => {
    const excelResponse = await checkoutBooksTrigger({
      ...searchData,
      page: 1,
      pageSize: 9999999,
    });
    const data = excelResponse?.data?.data?.checkedOutDtos;

    if (!data) return;

    const _data = data.map((item: any) => {
      if (!item.smsSender) {
        return {
          ...item,
          memberName: `${item.memberName}(${item.webId})`,
          bookName: `${item.bookName}(${item.bookSeq})`,
          classStudentStatusCode: getCommonCodeLabel(
            'CL0003',
            item.classStudentStatusCode?.trim() || '',
            i18n.language,
          ),
          mobilePhone: addHyphen(item.mobilePhone),
          lendingDate: moment(item.lendingDate).format('YYYY-MM-DD'),
          returnPlanDate: item?.overdueDay
            ? `${moment(item?.returnPlanDate).format('YYYY-MM-DD')}(${
                item?.overdueDay
              }${t('booksManagement.books.column22')})`
            : moment(item?.returnPlanDate).format('YYYY-MM-DD'),
          smsSender: '-',
        };
      }

      return {
        ...item,
        memberName: `${item.memberName}(${item.webId})`,
        bookName: `${item.bookName}(${item.bookSeq})`,
        classStudentStatusCode: getCommonCodeLabel(
          'CL0003',
          item.classStudentStatusCode?.trim() || '',
          i18n.language,
        ),
        mobilePhone: addHyphen(item.mobilePhone),
        lendingDate: moment(item.lendingDate).format('YYYY-MM-DD'),
        returnPlanDate: item?.overdueDay
          ? `${moment(item?.returnPlanDate).format('YYYY-MM-DD')}(${
              item?.overdueDay
            }${t('booksManagement.books.column22')})`
          : moment(item?.returnPlanDate).format('YYYY-MM-DD'),
        smsSender: 'Y',
      };
    });
    const excelColumns = [
      ..._.cloneDeep(returnBooksColumns),
      {
        title: t('booksManagement.books.column24'),
        dataIndex: 'mobilePhone',
        align: 'center',
      },
    ];

    const currentDate = moment(new Date());
    exportTable(
      excelColumns,
      _data,
      `${t('books.text.12')}_(${currentDate.format('YYYYMMDD')})`,
      t('books.text.13'),
      [10, 20, 20, 20, 20, 30, 20, 30, 30, 15, 20, 20, 20],
    );
  };

  useEffect(() => {
    if (!campusCode) return;

    setSearchData({ ...searchData, classCode, teacherMemberCode, campusCode, semesterType: semesterType===''?undefined:semesterType});
    execute(getEmployees({ campusCode, authGroup: 'T' }));
  }, [campusCode]);

  useEffect(() => {
    if (!campusCode || !rgCurrentSemester?.semesterCode) return;

    rgClassExecute(getClasses(campusCode, rgCurrentSemester!.semesterCode));
  }, [campusCode, rgCurrentSemester]);

  useEffect(() => {
    if (!campusCode || !scCurrentSemester?.semesterCode) return;

    scClassExecute(getClasses(campusCode, scCurrentSemester!.semesterCode));
  }, [campusCode, scCurrentSemester]);

  useEffect(() => {
    if (!page) return;

    setSearchData({ ...searchData, classCode, teacherMemberCode, page, semesterType: semesterType===''?undefined:semesterType});
  }, [page]);

  useEffect(() => {
    if (!isOverdueSMSLoading && isOverdueSMSSuccess) {
      enqueueSnackbar(t('booksManagement.books.message6'), successVariant);
    }
  }, [isOverdueSMSLoading, isOverdueSMSSuccess]);

  useEffect(() => {
    if (barcode != null && keywordRef) {
      setSearchData({
        ...searchData,
        classCode,
        teacherMemberCode,
        bookKeyword: barcode,
        page: 1,
        semesterType
      });
      keywordRef.current.value = barcode;
      handleSelectedReset();
    }
  }, [barcode]);

  useEffect(() => {
    //semesterExecute(getCurrentSemester());
    scSemesterExecute(getCurrentSemesterByType('SC'));
    rgSemesterExecute(getCurrentSemesterByType('RG'));
  }, []);

  useEffect(() => {
    if(scSemesterData) {
      setScCurrentSemester(scSemesterData?.data);
    }
  }, [scSemesterData]);

  useEffect(() => {
    setRgCurrentSemester(rgSemesterData?.data);
  }, [rgSemesterData]);

  useEffect(() => {
    const tempClassList: IClassList[] = [];

    if(rgClassList) {
      tempClassList.push(...rgClassList.data)
    }

    if(scClassList) {
      tempClassList.push(...scClassList.data)
    }

    setClassList(tempClassList);
  }, [scClassList, rgClassList]);

  return (
    <>
    <SimpleHeader
      iconFile="icon-event-big.svg"
      parentMenu={t('common.menu.book')}
      currentMenu={t('booksManagement.books.menu1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>
              {t('program.semester.column11')}
            </label>
            <Select
              className="w-120p"
              value={semesterType}
              onChange={value => setSemesterType(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                PR0002?.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>      
          <li>
            <label>{t('common.menu.class')}</label>
            <div>
              <Select
                placeholder={t('common.menu.class')}
                value={classCode}
                onChange={(value) => setClassCode(value)}
                style={{ width: '200px' }}
              >
                <Select.Option key={'all'} value={''}>
                  {t('common.text.all')}
                </Select.Option>
                {classList?.filter((si: any) => semesterType === '' || semesterType === si.semesterType).map((item: any) => {
                  return (
                    <Select.Option
                      key={item.classCode}
                      value={item.classCode}
                    >
                      {item.className}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('booksManagement.books.column18')}</label>
            <div>
              <Select
                placeholder={t('booksManagement.books.column18')}
                value={teacherMemberCode}
                onChange={(value) => setTeacherMemberCode(value)}
              >
                <Select.Option key={'all'} value={''}>
                  {t('common.text.all')}
                </Select.Option>
                {res?.data?.map((item: any, index: number) => {
                  return (
                    <Select.Option
                      key={item.memberCode + index}
                      value={item.memberCode}
                    >
                      {i18n.language === 'ko'
                        ? item?.memberName
                        : item?.memberEngName}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('booksManagement.books.column25')}</label>
            <input
              type="text"
              ref={keywordRef}
              className="form-control w-150p"
              placeholder={t('booksManagement.books.column25')}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  setSearchData({
                    ...searchData,
                    classCode,
                    teacherMemberCode,
                    bookKeyword: keywordRef.current.value,
                    page: 1,
                    semesterType: semesterType===''?undefined:semesterType
                  });
                  handleSelectedReset();
                }
              }}
            />
          </li>
          <li>
            <label>{t('booksManagement.books.column26')}</label>
            <input
              type="text"
              ref={studentKeywordRef}
              className="form-control w-150p"
              placeholder={t('booksManagement.books.column26')}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  setSearchData({
                    ...searchData,
                    classCode,
                    teacherMemberCode,
                    studentKeyword: studentKeywordRef.current.value,
                    page: 1,
                    semesterType: semesterType===''?undefined:semesterType
                  });
                  handleSelectedReset();
                }
              }}
            />
            <div className='comm-btn__area'>
              <Button
                className="btn-basic small black"
                onClick={() => {
                  setSearchData({
                    ...searchData,
                    classCode,
                    teacherMemberCode,
                    bookKeyword: keywordRef.current.value,
                    page: 1,
                    semesterType: semesterType===''?undefined:semesterType
                  });
                  handleSelectedReset();
                }}
                text={t('common.button.search')}
              />
            </div>
          </li>          
        </ul>
      </div>
    </div>

    <div className="content scrollbar">
      <ErrorResponse error={error} />
      <ErrorResponse error={teachersError} />

      <div className="comm-bx__between">
        <div className="comm-sch_result">
          {t('common.text.count')}: <b>{checkedOutBooks?.totalCount ?? 0}</b>
          {t('common.text.unit')}
        </div>
      </div>
      <div className='comm-table__area'>
        <Table
          columns={returnBooksColumns}
          dataSource={checkedOutBooks?.checkedOutDtos ?? []}
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          loading={isFetching}
          pagination={{
            current: searchData.page,
            pageSize: searchData.pageSize,
          }}
          // onRow={(record: any) => console.log(1)}
          rowClassName="pointer"
          rowKey="no"
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={handleExcelTable} />
        <div className="common-paging center">
          <Pagination
            count={checkedOutBooks?.totalCount ?? 0}
            page={searchData.page}
            perPage={searchData.pageSize}
            setPage={setPage}
          />
        </div>
        <div className='comm-btn__area'>
          <Button
            className="btn-basic pink-line"
            onClick={() => {
              if (selectedBooks.length <= 0) {
                enqueueSnackbar(
                  t('booksManagement.books.message7'),
                  infoVariant,
                );
                return;
              }

              const data = {
                campusCode,
                campusName: campusData?.find(
                  (item) => item.campusCode === campusCode,
                )?.campusKorName,
                telephoneNo: campusData?.find(
                  (item) => item.campusCode === campusCode,
                )?.telephoneNo,
                overdueStudent: selectedBooks,
              };

              overdueSMSSendTrigger(data);
              handleSelectedReset();
            }}
            text={t('booksManagement.books.button3')}
          />
        </div>
      </div>
    </div>
    </>
  );
};

export default CheckedOutBooks;
